module.exports = __webpack_public_path__ + "static/media/16UNODC28.cadf61a4.jpg";